
import * as ipxRuntime$R0ldtgpdt6 from '/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [
    "sedna-language.com",
    "test-sedna.cyclops.care",
    "sednalanguage.ir"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "jpeg",
    "webp",
    "webp"
  ],
  "quality": 80
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$R0ldtgpdt6, defaults: {} }
}
        